module.exports = __webpack_public_path__ + "img/v_clubs.e59c6280.png";